export default __webpack_public_path__ + "static/media/users-phone.12f6a8a3.png";